<template>
  <div>
    <div style="padding-top: 5px">
      <el-form inline size="small" :model="form">
        <el-form-item label="时间粒度">
          <el-select v-model="form.timeDim" size="small" style="width: 80px" @change="changeDate">
            <el-option v-for="item in timeDim_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间维度">
          <el-date-picker size="small" style="width: 135px" v-model="form.selectTime" :type="date_type" @change="timeFormat" :clearable="clearable" :picker-options="picker_options" :format="formatt" :value-format="formatTime">
          </el-date-picker>
        </el-form-item>
        <ChannelSelect :getChannelData="getChannelData"></ChannelSelect>
        <el-form-item>
          <el-button type="primary" @click="search">查 询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="exportTrend">导 出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-table :data="tableData" max-height="500" :header-cell-style="{
          background: '#f5f5f5',
          borderRight: '1px solid #fff',
          textAlign: 'center',
          height: '44px',
          lineHeight: '18px',
          fontWeight: 'normal',
          color: '#333',
        }" class="table-main">
        <el-table-column align="center" v-for="header in tableShowColumns" :key="header.label" :prop="header.prop" :label="header.label" :formatter="header.formatter" :min-width="header.minWidth ? header.minWidth: ''" :show-overflow-tooltip="header.overflowTooltip? header.overflowTooltip: false"
                         :fixed="header.fixed? header.fixed: false" :sortable="header.sortable? header.sortable: false" :sort-method="header.sortMethod">
        </el-table-column>
      </el-table>
      <!-- <div class="table-page" v-show="form.timeDim !== '3'">
        <el-pagination
          class="work-mt20 work-mb20"
          @current-change="handleCurrentChange"
          :current-page="form.page"
          :page-size="form.limit"
          layout="total, prev, pager, next, jumper"
          :total="totalPage"
        >
        </el-pagination>
      </div> -->
      <FieldSelection ref="fieldSelect" :tableColumns="tableColumns"></FieldSelection>
    </el-row>
    <el-row class="grid-content el-col_1" style="margin-top: 20px; padding-left: 0px">
      <el-col>
        <ve-line :data="lineData" :extend="lineChartExtend" :settings="lineChartSetting" ref="queue_trend_line"></ve-line>
      </el-col>
    </el-row>
    <MyProgress progressTitle="导出排队趋势分析" :progressTaskId="progressTaskId" ref="exprtProgress" :progressFinish="exprotFinish"></MyProgress>
  </div>
</template>
<script>
import { getQueueInfo, exportQueueTrendReport, downExcelFile } from '@/api/report'
import QueueDetail from '@/views/workreport/queue/analyze/QueueDetail'
import MyProgress from '@/views/myprogress/MyProgress.vue'
import fileDownload from 'js-file-download'
import moment from 'moment'
import ChannelSelect from '@/views/workreport/components/public/ChannelSelect'
import FieldSelection from '@/views/workreport/components/public/FieldSelection'

export default {
  name: 'QueueTrend',
  components: {
    moment,
    QueueDetail,
    ChannelSelect,
    MyProgress,
    FieldSelection
  },
  data() {
    this.lineChartExtend = {
      legend: {
        bottom: 10,
        textStyle: {
          fontSize: 11
        }
      },
      grid: {
        left: '5%',
        right: '3%'
      },
      yAxis: {
        splitLine: {
          lineStyle: {
            type: 'dotted'
          }
        },
        position: 'left',
        nameTextStyle: {
          color: '#606266',
          fontSize: 12,
          fontWeight: 'lighter'
        }
      }
    }
    this.lineChartSetting = {
      labelMap: {
        timeZoe: '日期',
        totalQueueCount: '排队数',
        queueAcceptCount: '进入咨询数',
        leaveMsgCount: '进入留言数',
        queueExitCount: '放弃排队数'
      }
    }
    return {
      lineData: {
        columns: ['timeZoe', 'totalQueueCount', 'queueAcceptCount', 'leaveMsgCount', 'queueExitCount'],
        rows: []
      },
      showPro: false,
      tableColumns: [{
        prop: 'timeZoe',
        label: '时间',
        minWidth: '120px',
        canSelect: true,
        isShow: true,
        sortable: true,
        excludeSelected: true
      }, {
        prop: 'totalQueueCount',
        label: '排队数',
        minWidth: '115px',
        canSelect: true,
        isShow: true,
        sortable: true
      }, {
        prop: 'queueAcceptCount',
        label: '进入咨询数',
        minWidth: '115px',
        canSelect: true,
        isShow: true,
        sortable: true
      }, {
        prop: 'leaveMsgCount',
        label: '进入留言数',
        minWidth: '115px',
        canSelect: true,
        isShow: true,
        sortable: true
      }, {
        prop: 'queueExitCount',
        label: '放弃排队数',
        minWidth: '115px',
        canSelect: true,
        isShow: true,
        sortable: true
      }, {
        prop: 'maxQueueCount',
        label: '115px',
        minWidth: '最大排队数',
        canSelect: false,
        isShow: false,
        sortable: true
      }, {
        prop: 'maxQueueTime',
        label: '进入咨询排队最长时间',
        minWidth: '205px',
        canSelect: true,
        isShow: true,
        sortable: true
      }, {
        prop: 'avgQueueTime',
        label: '进入咨询排队平均时间',
        minWidth: '205px',
        canSelect: true,
        isShow: true,
        sortable: true
      }, {
        prop: 'queueAcceptRate',
        label: '排队接入率',
        minWidth: '145px',
        canSelect: false,
        isShow: false,
        sortable: true
      }, {
        prop: 'avgQueueExitTime',
        label: '放弃平均时间',
        minWidth: '115px',
        canSelect: true,
        isShow: true,
        sortable: true
      }],
      tableData: [],
      limit: 10,
      totalPage: 0,
      form: {
        timeDim: '1',
        selectTime: moment(new Date()).format('yyyy-MM-DD'),
        skillGroupId: 'all',
        dims: {}
      },
      timeDim_options: [
        { label: '时', value: '1' },
        { label: '天', value: '2' },
        { label: '月', value: '3' }
      ],
      picker_options: {
        disabledDate: (time) => {
          return time.getTime() >= Date.now()
        }
      },
      date_type: 'date',
      formatt: '',
      formatTime: 'yyyy-MM-dd',
      clearable: false,
      page: 1,
      limitUserGroupIds: [],
      progressTaskId: 'export-queue-trend'
    }
  },
  created() {
    this.getData(1)
  },
  computed: {
    tableShowColumns() {
      return this.tableColumns.filter(item => item.isShow === true)
    }
  },
  methods: {
    changeDate() {
      this.form.selectTime = ''
      if (this.form.timeDim === '1') {
        this.date_type = 'date'
        this.formatTime = 'yyyy-MM-dd'
        this.form.selectTime = moment(new Date()).format('yyyy-MM-DD')
      } else if (this.form.timeDim === '2') {
        this.date_type = 'month'
        this.formatTime = 'yyyy-MM'
        this.form.selectTime = moment(new Date()).format('yyyy-MM')
      } else if (this.form.timeDim === '3') {
        this.date_type = 'year'
        this.formatTime = 'yyyy'
        this.form.selectTime = moment(new Date()).format('yyyy')
      }
    },
    search() {
      this.form.limitUserGroupIds = this.limitUserGroupIds
      this.showReturn = false
      this.getData()
    },
    handleCurrentChange(page) {
      this.getData(page)
    },
    getData(_page) {
      getQueueInfo(this.form).then((res) => {
        this.tableData = res.data.data.data
        this.totalPage = res.data.data.total
        this.lineData.rows = this.tableData
      })
    },
    getChannelData(data) {
      this.form.dims = data
    },
    timeFormat(val) {
      this.form.selectTime = val
    },
    exportTrend() {
      const self = this
      this.form.progressId = this.progressTaskId
      this.form.exportHeader = this.$refs.fieldSelect.getHeader()
      exportQueueTrendReport(this.form).then(
        res => {
          self.$refs.exprtProgress.startProgress()
        }
      )
    },
    exprotFinish(data) {
      downExcelFile({ excelName: data.fileName }).then(res => {
        fileDownload(res, data.fileName)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-col_1 {
  height: 100%;
  border-radius: 4px;
  border: 1px solid #e3e7e1;
}
.grid-content {
  height: 100%;
  border-radius: 4px;
}
.el-form--inline {
  ::v-deep .el-form-item {
    margin-bottom: 10px !important;
    margin-right: 20px;
  }
  ::v-deep .el-form-item__label {
    padding: 0 6px 0 0;
  }
  ::v-deep .el-form-item .el-form-item {
    margin-bottom: 0px !important;
    margin-right: 20px;
  }
  ::v-deep .el-form-item .el-form-item:last-child {
    margin-right: 0px;
  }
  ::v-deep .el-form-item:nth-last-child(2) {
    margin-right: 10px;
  }
}
</style>
